export enum Protocol {
    HTTP = 'http',
    HTTPS = 'https'
}

export interface ApiDiscoveryEntry {
    datacenter?: 'Europe' | 'OnPrem';
    tkId?: string;
    host: string;
    path: `${string}/${string}`;
    protocols: Protocol[];
    products?: [
        {
            name: string;
            subscriptionRequired: boolean;
        }
    ];
    apiVersion?: {
        name?: string;
        versionHeader?: string;
        defaultVersion: boolean;
    };
    /**
     * true only for OnPrem Services
     */
    keepRestPathElement?: true;
}
